export default __webpack_public_path__ + "static/media/convert-ecredit-to-epoint-step2.4fcb8383.png";